import { defineStore } from "pinia";
import { useOidcStore } from "vue3-oidc";
import { useRepo } from "pinia-orm";
import User from "@/models/User.js";
import { userApi } from "@/setup/api/apollo-sync-back.js";

export const useUserStore = defineStore("user", {
  getters: {
    getCurrentUser: () => () => {
      return useRepo(User).where("isCurrentUser", true).first();
    },
  },
  actions: {
    async fetchCurrentUser() {
      const oidcStore = useOidcStore();
      const userRepo = useRepo(User);
      const profile = oidcStore.state.value?.user?.profile;
      if (!profile?.usermanagementUuid) {
        throw new Error("OIDC profile not available");
      }
      const user = await userApi.retrieve({
        usermanagementUuid: profile.usermanagementUuid,
      });
      userRepo.save({
        ...user,
        isCurrentUser: true,
      });
    },
  },
});
